/* eslint-disable */
export default {
    init() {
    },
    finalize() {
        var lat = $('#map').data('lat'),
            long = $('#map').data('long'),
            markerIcon = $('#map').data('marker'),
            name = $('#map').data('name'),
            address = $('#map').data('address'),
            addressUrl = $('#map').data('addressUrl'),
            phone = $('#map').data('phone');

        if (document.getElementById('map') == null)
        {
          return;
        }

        var map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: lat, lng: long},
            zoom: 15,
            styles: [
                {
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#f5f5f5"
                    }
                  ]
                },
                {
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#54585A"
                    }
                  ]
                },
                {
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#616161"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.stroke",
                  "stylers": [
                    {
                      "color": "#f5f5f5"
                    }
                  ]
                },
                {
                  "featureType": "administrative.country",
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#3df4f4"
                    }
                  ]
                },
                {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#bdbdbd"
                    }
                  ]
                },
                {
                  "featureType": "landscape.man_made",
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#f4f4f4"
                    }
                  ]
                },
                {
                  "featureType": "landscape.natural",
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#f4f4f4"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#eeeeee"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#757575"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                },
                {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#ffffff"
                    }
                  ]
                },
                {
                  "featureType": "road.arterial",
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#54585A"
                    }
                  ]
                },
                {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#757575"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#dadada"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#54585A"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#616161"
                    }
                  ]
                },
                {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                },
                {
                  "featureType": "transit.line",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "transit.station",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#eeeeee"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#c9c9c9"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#54585A"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                }
               ]
        });

        var marker = new google.maps.Marker({
          position: {lat: lat, lng: long},
          map: map,
          icon: {
            url: markerIcon,
            scaledSize: new google.maps.Size(94, 53)
          },
          title: 'Crowne Plaza Hunter Valley',
        });

        var infowindow = new google.maps.InfoWindow({
          content: `<div class="maps-infowindow">
                      <a class="get-directions" href="${addressUrl}" target="_blank">Get Directions <i class="fal fa-chevron-circle-right"></i></a>
                      <h3>${name}</h3>
                      <p class="address">${address}</p>
                      <p class="phone">Phone: <a href="tel:${phone}">${phone}</a></p>
                    </div>`,
        });

        marker.addListener('click', function() {
          infowindow.open(map, marker);

          setTimeout(function() {
            $('.maps-infowindow').parents('.gm-style-iw-a').addClass('infowindow-wrapper');
          }, 1)
        });

        google.maps.event.addListener(map, "click", function(event) {
          infowindow.close();
      });

      $('a[href="#open-map"]').click(function() {
        infowindow.open(map, marker);
      })
    },
};



// WEBPACK FOOTER //
// ./scripts/components/maps.js